module.exports = __webpack_public_path__ + "static/media/download-disabled.4b7b6d5c.svg";